<i18n>
{
  "fr": {
    "specifications": "Spécifications",
    "documents-completed": "Documents complétés",
    "specific-indicators": "Indicateurs spécifiques"
  },
  "en": {
    "specifications": "Specifications",
    "documents-completed": "Completed documents",
    "specific-indicators": "Specific indicators"
  }
}
</i18n>

<template>
  <div>
    <h3 class="has-letter-spacing-wide has-text-grey has-text-weight-medium is-uppercase is-size-7 mb-4px">
      {{ $t('specifications') }}
    </h3>
    <ui-bar>
      <ui-bar-element
        v-if="data.directDocumentsCount > 0"
        type="count-item"
        :text="$t('documents-completed')"
        :count="data.directDocumentsCompletedCount"
        :total="data.directDocumentsCount"
        color="grey-dark"
        hasSeparator
        isUppercase
      />

      <ui-bar-element
        type="label-item"
        :text="$t('specific-indicators')"
        color="turquoise"
        :count="data.directIndicatorsCount"
        :icon="specificIcon"
        isUppercase
        isSpecific
      />

      <ui-bar-element isAlignRight>
        <slot></slot>
      </ui-bar-element>
    </ui-bar>
  </div>
</template>

<script>
import UiBar from '@/components/ui/bar'
import UiBarElement from '@/components/ui/bar-element'

const SPECIFIC_ICON = {
  backgroundColor: 'pale-turquoise',
  color: 'turquoise',
  icon: '',
  customIcon: require('@/assets/icon-specific.svg'),
  text: null,
  isCircle: false
}

export default {
  components: {
    UiBar,
    UiBarElement
  },
  props: {
    data: Object
  },
  data() {
    return {
      specificIcon: SPECIFIC_ICON
    }
  }
}
</script>

